import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BookOpen } from 'lucide-react';
import { systemDisplayName } from '../config/familyRegistry';

/**
 * A page the active system lacks but another system has (issue 973).
 *
 * The decision recorded on the issue: the same page in the new system, empty,
 * with a short note linking to the system that has it, as the shared families
 * already behave. The link is a full load because a `?system=` on the initial
 * URL is what switches the system (#92).
 */
export default function FamilyElsewhere({ segment, system, elsewhere }) {
  const plural = elsewhere.family.labels.plural;
  const here = systemDisplayName(system);
  return (
    <>
      <Helmet>
        <title>{plural} - The Dragon&apos;s Table</title>
      </Helmet>
      <div className="space-y-6">
        <div className="page-header">
          <BookOpen className="page-icon" />
          <h1 className="page-title">{plural}</h1>
        </div>
        <div className="card text-center py-12" data-testid="family-elsewhere">
          <p className="no-results">
            {here} has no {plural} yet.{' '}
            <a href={`/${segment}?system=${encodeURIComponent(elsewhere.system)}`} className="underline">
              The {elsewhere.systemName} {plural} is here
            </a>.
          </p>
        </div>
      </div>
    </>
  );
}
